import React, { useState, useMemo, useEffect, } from "react";
import { useParams, useOutletContext, useNavigate, } from 'react-router-dom';

import Details from "../details";

import { getActivity } from "../../services";

const PlanActivity = () => {
  const { uuid } = useParams();
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [userState, dispatch] = useOutletContext();
  const [useShareVersion, setUseShareVersion] = useState(false);
  const navigate = useNavigate();
  // console.log(`PlanActivity uuid: ${uuid}`);

  useMemo(() => {
    getActivity(uuid).then((result) => {
      // console.log(`PlanActivity getActivity result.id: ${result.id}`);
      if (!result.id) {
        // Maybe activity exists but we are not the owner -> resend to share
        setSelectedActivity(null);
        setUseShareVersion(true);
      }
      else {
        // console.log(`PlanActivity update activity id result.id: ${result.id}`);
        setSelectedActivity(result);
        setSelectedActivityId(result?.id);
        setUseShareVersion(false);
        dispatch({ type: "SET_ACTIVITY_UUID", payload: uuid });
        dispatch({ type: "SET_ACTIVITY_ID", payload: result.id });
        }
    })
    .catch((error) => {
      console.log(error);
      setSelectedActivity(null);
      setUseShareVersion(true);
    });
  }, [uuid, dispatch]);

  useEffect(() => {
    if (useShareVersion) {
      // console.log("redirect to share");
      navigate(`/share/activity/${uuid}`);
    }
  }, [useShareVersion, navigate, uuid]);
  
  return (
    <Details
      activityId={selectedActivityId}
      selectedActivity={selectedActivity}
      stripeLevel={userState.userStripeLevel}
      isUserLoggedIn={userState.isUserLoggedIn}
      allowCookies={userState.allowedCookies}
      userPrefUnitLabels={userState.userPrefUnits}
    />
  );
}

export default PlanActivity;